export default __webpack_public_path__ + "static/product5-bdbb8bf9ba43e1185a659834fd8ca743.png";